import { Archer } from './Archer';
import { Projectile } from '../Projectile';
import { LONGBOW_ARCHER } from '../../config';
import { StickFigureGraphics } from '../../rendering/StickFigureGraphics';

export class LongbowArcher extends Archer {
    protected config = LONGBOW_ARCHER;

    constructor(scene: Phaser.Scene, x: number, y: number, slotIndex: number, projectiles: Projectile[]) {
        super(scene, x, y, slotIndex, projectiles);
        this.targetPriority = 'highestHP';
        this.sprite.setFlipX(true);
    }

    draw(): void {
        if (this.drawPhase <= 0) {
            this.sprite.setTexture('friendly_longbow_archer_idle');
        } else {
            let frame = Math.floor(this.drawPhase * 8);
            if (frame < 0) frame = 0;
            if (frame > 7) frame = 7;
            this.sprite.setTexture(`friendly_longbow_archer_${frame}`);
        }

        this.graphics.clear();

        // Level indicator (green for poison)
        if (this.level > 1) {
            this.graphics.fillStyle(0x44cc44, 1);
            for (let i = 0; i < Math.min(this.level - 1, 5); i++) {
                this.graphics.fillCircle(this.x - 8 + i * 4, this.y + 16, 1.5);
            }
        }
    }
}
